/**
 * Client-side feature gates (Vite: must use `VITE_` prefix in `.env`).
 *
 * Patron screening prototype embeds reference/mock screening rows.
 * - Unset: **on in dev** (`vite`/npm start), **off in production builds** (mock stays out of prod UX).
 * - `VITE_ENABLE_PATRON_SCREENING_PROTOTYPE=true` — always on.
 * - `VITE_ENABLE_PATRON_SCREENING_PROTOTYPE=false` — always off (even in dev).
 *
 * @see docs/MOCK_REPLACEMENT_CHECKLIST.md Phase D
 */
export function isPatronScreeningPrototypeEnabled() {
  const v = import.meta.env.VITE_ENABLE_PATRON_SCREENING_PROTOTYPE
  if (v === 'false') return false
  if (v === 'true') return true
  return Boolean(import.meta.env.DEV)
}
